!function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports.clientLogs = n() : e.clientLogs = n();
}(this, function () {
  return function (e) {
    var n = {};

    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, n) {
      if (1 & n && (e = t(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var o in e) {
        t.d(r, o, function (n) {
          return e[n];
        }.bind(null, o));
      }
      return r;
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, t.p = "", t(t.s = 0);
  }([function (e, n, t) {
    "use strict";

    t.r(n);

    var r = ["info", "log", "warn", "error"],
        o = {
      keepMessageCount: 100,
      keepMessageTypes: ["error"],
      logMessageTypes: ["error"],
      namespace: void 0
    },
        s = function s(e) {
      return e.reduce(function (e, n) {
        return e[n] = !0, e;
      }, Object.create(null));
    },
        u = function () {
      function e(e) {
        this._messages = [], this._maxLength = e;
      }

      return e.prototype.push = function (e) {
        this._messages.push(e), this._messages.length > this._maxLength && this._messages.splice(0, this._messages.length - this._maxLength);
      }, e.prototype.getMessages = function (e) {
        var n,
            t,
            o = s(null != (t = null === (n = e) || void 0 === n ? void 0 : n.messageTypes) ? t : r);
        return this._messages.filter(function (e) {
          return o[e.type];
        });
      }, e;
    }();

    function a(e) {
      return e;
    }

    t.d(n, "makeConsole", function () {
      return p;
    }), t.d(n, "version", function () {
      return f;
    }), t.d(n, "makeOptions", function () {
      return l;
    });

    var _i = function i() {
      return (_i = Object.assign || function (e) {
        for (var n, t = 1, r = arguments.length; t < r; t++) {
          for (var o in n = arguments[t]) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        c = function c() {
      for (var e = 0, n = 0, t = arguments.length; n < t; n++) {
        e += arguments[n].length;
      }

      var r = Array(e),
          o = 0;

      for (n = 0; n < t; n++) {
        for (var s = arguments[n], u = 0, a = s.length; u < a; u++, o++) {
          r[o] = s[u];
        }
      }

      return r;
    },
        p = function p(e) {
      var n = _i(_i({}, o), null != e ? e : {}),
          t = new u(n.keepMessageCount),
          p = s(n.logMessageTypes),
          f = s(n.keepMessageTypes);

      return r.reduce(function (e, r) {
        var o = null != n.namespace ? function (e) {
          return c([n.namespace], e);
        } : a,
            s = p[r] ? console[r] : a,
            u = f[r] ? function (e) {
          return t.push({
            type: r,
            args: e
          });
        } : a;
        return e[r] = function () {
          for (var e = [], n = 0; n < arguments.length; n++) {
            e[n] = arguments[n];
          }

          var t = o(e);
          s.apply(void 0, t), u(t);
        }, e;
      }, {
        getMessages: function getMessages(e) {
          return t.getMessages(e);
        }
      });
    },
        f = "1.0.0";

    function l(e, n) {
      switch (e) {
        case "production":
          return _i(_i({}, o), {
            keepMessageTypes: ["error"],
            logMessageTypes: [],
            namespace: n
          });

        case "error":
          return _i(_i({}, o), {
            keepMessageTypes: ["warn", "error"],
            logMessageTypes: ["error"],
            namespace: n
          });

        case "verbose":
          return _i(_i({}, o), {
            keepMessageTypes: [],
            logMessageTypes: r.slice(),
            namespace: n
          });
      }
    }

    n.default = p;
  }]);
});